import {useAppSelector} from "@Hooks/selector/useAppSelector";
import {useLazyRemoveVoucherQuery} from "@CheckOrder/api/checkOrderApi";

export default function useRemoveVoucher() {
    const [removeVoucher] = useLazyRemoveVoucherQuery()
    const {ticket} = useAppSelector((state) => state?.checkOrder)

    return () => removeVoucher({
        ticket,
        ticket_code: ticket.ticketCode,
    })
}